webpackJsonp([8],{

/***/ 1906:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1962)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1925),
  /* template */
  __webpack_require__(1989),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-947c6268",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_pre_retirada_services__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_popup_viewer_PopupViewerAlert__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default_components_popup_viewer_PopupViewerAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__default_components_popup_viewer_PopupViewerAlert__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BtnAlteraDataPagamentoPreretirada',
  components: { PopupViewerAlert: __WEBPACK_IMPORTED_MODULE_1__default_components_popup_viewer_PopupViewerAlert___default.a },
  props: {
    preRetiradaId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      dataPagamento: null,
      show: false
    };
  },

  methods: {
    setDataPagamento: function setDataPagamento() {
      var _this = this;

      var dataPagamentoFormatada = this.dataPagamento.split('-').reverse().join('/');
      if (!confirm('ATEN\xC7\xC3O: Confirmar altera\xE7\xE3o da data de pagamento para "' + dataPagamentoFormatada + '"?')) {
        this.show = false;
        this.dataPagamento = null;
        return;
      }
      this.$loaderOverlay.open().message('Alterando a data de pagamento...');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__domain_pre_retirada_services__["g" /* alteraDataPagamento */])(this.preRetiradaId, this.dataPagamento).then(function (response) {
        _this.show = false;
        _this.dataPagamento = null;
        _this.$emit('dataAlterada', response.data.dataPagamento);
      }).catch(function (error) {
        alert('Houve um erro ao alterar a data de pagamento');
        console.log(error.data);
      }).finally(function () {
        _this.$loaderOverlay.hide();
      });
    },
    toggleShow: function toggleShow() {
      this.show = !this.show;
    },
    cancelar: function cancelar() {
      this.dataPagamento = null;
      this.show = false;
    }
  }
});

/***/ }),

/***/ 1951:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1903)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BtnAlteraDataPagamentoPreretirada.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1962:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1904)("6477dc28", content, true, {});

/***/ }),

/***/ 1989:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-t-sm m-b-sm"
  }, [_c('a', {
    staticClass: "btn btn-default font-bold btn-dark",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v(_vm._s(_vm.show ? 'Cancelar' : 'Alterar data de pagamento'))])]), _vm._v(" "), (_vm.show) ? _c('popup-viewer-alert', {
    attrs: {
      "title": "Alteração manual de data de pagamento"
    }
  }, [_c('div', {
    staticClass: "form-group m-t-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataPagamento),
      expression: "dataPagamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dataPagamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataPagamento = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default m-l",
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info m-l",
    attrs: {
      "disabled": !_vm.dataPagamento
    },
    on: {
      "click": _vm.setDataPagamento
    }
  }, [_vm._v("Confirmar")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.fb8bb7d54e3ba394da08.js